// 即日発送締め切り時間
const limitHour = 12
const displayHour = 11
// 休日 (日付)
const holidayDate = [
  '2024/1/1',     //元日	
  '2024/1/2',
  '2024/1/3',	
  '2024/1/4',
  '2024/1/8',    //成人の日
  '2024/2/11',    //建国記念の日
  '2024/2/12',    //振替休日
  '2024/2/23',    //天皇誕生日
  '2024/3/20',    //春分の日	
  '2024/4/29',    //昭和の日	
  '2024/5/3',   //憲法記念日	
  '2024/5/4',    //みどりの日	
  '2024/5/5',   //こどもの日
  '2024/5/6',   //振替休日
  '2024/7/15',    //海の日	
  '2024/8/11',   //山の日	
  '2024/8/12',    //振替休日
  '2024/8/13',    //夏季休業
  '2024/8/14',    //夏季休業
  '2024/8/15',    //夏季休業
  '2024/9/16',   //敬老の日
  '2024/9/22',   //秋分の日
  '2024/9/23',   //振替休日
  '2024/10/14',   //スポーツの日
  '2024/11/3',   //文化の日
  '2024/11/4',   //振替休日
  '2024/11/23',   //勤労感謝の日
  '2024/12/30',   //冬季休業
  '2024/12/31',   //冬季休業
  '2025/1/1',   //冬季休業
  '2025/1/2',   //冬季休業
  '2025/1/3',   //冬季休業
  '2025/1/13',   //成人の日
  '2025/2/11',   //建国記念の日
  '2025/2/24',   //天皇誕生日
  '2025/3/20',   //春分の日
  '2025/4/29',   //昭和の日
  '2025/5/3',   //憲法記念日
  '2025/5/4',   //みどりの日
  '2025/5/5',   //こどもの日
  '2025/5/6',   //振替休日
  '2025/7/21',   //海の日
  '2025/8/11',   //山の日
  '2025/9/15',   //敬老の日
  '2025/9/23',   //秋分の日
  '2025/10/13',   //スポーツの日
  '2025/11/3',   //文化の日
  '2025/11/23',   //勤労感謝の日
  '2025/11/24',   //振替休日
  // ===== 2026年（令和8年）国民の祝日・休日（出典：内閣府） =====
  '2026/1/1',     //元日
  '2026/1/12',    //成人の日
  '2026/2/11',    //建国記念の日
  '2026/2/23',    //天皇誕生日
  '2026/3/20',    //春分の日
  '2026/4/29',    //昭和の日
  '2026/5/3',     //憲法記念日
  '2026/5/4',     //みどりの日
  '2026/5/5',     //こどもの日
  '2026/5/6',     //休日（振替休日）
  '2026/7/20',    //海の日
  '2026/8/11',    //山の日
  // ----- 2026年 夏季休業（8/13・8/14。8/15・8/16は土日で自動休業） -----
  '2026/8/12',    //夏季休業
  '2026/8/13',    //夏季休業
  '2026/8/14',    //夏季休業
  '2026/9/21',    //敬老の日
  '2026/9/22',    //休日（国民の休日）
  '2026/9/23',    //秋分の日
  '2026/10/12',   //スポーツの日
  '2026/11/3',    //文化の日
  '2026/11/23',   //勤労感謝の日
  // ----- 2026→2027年 年末年始休業（⚠️社内決定事項。日付は要確認） -----
  '2026/12/28',   //年末年始休業
  '2026/12/29',   //年末年始休業
  '2026/12/30',   //年末年始休業
  '2026/12/31',   //年末年始休業
  '2027/1/1',     //年末年始休業（元日）
  '2027/1/2',     //年末年始休業
  '2027/1/3',     //年末年始休業
]
  // 休日 (曜日)
  const holidayWeek = [
  '土',
  '日',
]
// 定休日を格納する
let shipDate = null
// ベースとなる日 (=今日)
const baseDate = new Date()
// 現在時刻
const hours = baseDate.getHours()

// 営業日 && 12時までの注文は当日出荷
if (!isHoliday(baseDate) && hours < limitHour) {
  shipDate = baseDate
} else {
  // 定休日を算出する
  do {
    // 1日ずつ加算
    baseDate.setDate(baseDate.getDate() + 1);
    // 休日でない場合
    if (!isHoliday(baseDate)) {
      shipDate = baseDate
    }
  } while (shipDate === null)
    }

    if (shipDate !== null) {
      // 注文日時
      // 年度を出す場合
      //document.getElementById('shipDate01').innerText = formatDate(shipDate, 'YYYY年MM月DD日')+limitHour+"時"
      document.getElementById('shipDate01').innerText = formatDate(shipDate, 'MM月DD日')+displayHour+"時59分"
      
      // 出荷日をHTMLに反映
      // 年度を出す場合
      //document.getElementById('shipDate02').innerText = formatDate(shipDate, 'YYYY年MM月DD日')
      document.getElementById('shipDate02').innerText = formatDate(shipDate, 'MM月DD日')
      
      document.getElementById('shipDate03').innerText = formatDate(shipDate, 'MM月DD日')+displayHour+"時59分"
      document.getElementById('shipDate04').innerText = formatDate(shipDate, 'MM月DD日')
    }

  /**
   * 休日かどうか判定する
   * @return boolean
   */
  function isHoliday(date) {
    const week = date.getDay()
    const weekString = ['日', '月', '火', '水', '木', '金', '土' ][week]
    return holidayDate.includes(formatDate(date, 'YYYY/MM/DD'))
    || holidayWeek.includes(weekString)
  }

  /**
   * 日付をフォーマットする
   * @param date
   * @param format
   * @returns {*}
   */
  function formatDate(date, format) {
    format = format.replace(/YYYY/, date.getFullYear());
    format = format.replace(/MM/, date.getMonth() + 1);
    format = format.replace(/DD/, date.getDate());
    return format;
  }